<template>
    <div>
                <base-header style="background: rgba(79, 47, 129, 1);
background: radial-gradient(circle, rgba(79, 47, 129, 1) 25%, rgba(79, 47, 129, 0.73) 100%);" class="pb-6 pb-8 pt-5 pt-md-5">
            <!-- Card stats -->
            <!-- <div class="row">
              <div class="container-fluid mt--7">
            <div class="row">
                <div class="col">
                    <div class="card shadow">
                        <div class="card-header bg-transparent">
                            <h3 class="mb-0">Icons</h3>
                        </div>
                        <div class="card-body">
                            <div class="col-xl-3 col-lg-6">
                    <base-button type="primary" style="width: 200px; height: 200px;">
                    <center>
                      <p class='ni ni-world'></p>
                      <p style="font-size: 40px;">World</p>
                    </center>
                  </base-button>
                </div>
                <div class="col-xl-3 col-lg-6">
                    <base-button type="primary" style="width: 200px; height: 200px;">
                    <center>
                      <p class='ni ni-world'></p>
                      <p style="font-size: 40px;">World</p>
                    </center>
                  </base-button>
                </div>
                <div class="col-xl-3 col-lg-6">
                    <base-button type="primary" style="width: 200px; height: 200px;">
                    <center>
                      <p class='ni ni-world'></p>
                      <p style="font-size: 40px;">World</p>
                    </center>
                  </base-button>
                </div>
                <div class="col-xl-3 col-lg-6">
                    <base-button type="primary" style="width: 200px; height: 200px;">
                    <center>
                      <p class='ni ni-world'></p>
                      <p style="font-size: 40px;">World</p>
                    </center>
                  </base-button>
                </div>
                <div class="col-xl-3 col-lg-6">
                    <base-button type="primary" style="width: 200px; height: 200px;">
                    <center>
                      <p class='ni ni-world'></p>
                      <p style="font-size: 40px;">World</p>
                    </center>
                  </base-button>
                </div>
                <div class="col-xl-3 col-lg-6">
                    <base-button type="primary" style="width: 200px; height: 200px;">
                    <center>
                      <p class='ni ni-world'></p>
                      <p style="font-size: 40px;">World</p>
                    </center>
                  </base-button>
                </div>
                        </div>
                    </div>
                </div>
            </div>
        </div> -->

                <!-- <div class="col-xl-3 col-lg-6">
                    <stats-card title="Total traffic"
                                type="gradient-red"
                                sub-title="350,897"
                                icon="ni ni-active-40"
                                class="mb-4 mb-xl-0"
                    >

                        <template slot="footer">
                            <span class="text-success mr-2"><i class="fa fa-arrow-up"></i> 3.48%</span>
                            <span class="text-nowrap">Since last month</span>
                        </template>
                    </stats-card>
                </div>
                <div class="col-xl-3 col-lg-6">
                    <stats-card title="Total traffic"
                                type="gradient-orange"
                                sub-title="2,356"
                                icon="ni ni-chart-pie-35"
                                class="mb-4 mb-xl-0"
                    >

                        <template slot="footer">
                            <span class="text-success mr-2"><i class="fa fa-arrow-up"></i> 12.18%</span>
                            <span class="text-nowrap">Since last month</span>
                        </template>
                    </stats-card>
                </div>
                <div class="col-xl-3 col-lg-6">
                    <stats-card title="Sales"
                                type="gradient-green"
                                sub-title="924"
                                icon="ni ni-money-coins"
                                class="mb-4 mb-xl-0"
                    >

                        <template slot="footer">
                            <span class="text-danger mr-2"><i class="fa fa-arrow-down"></i> 5.72%</span>
                            <span class="text-nowrap">Since last month</span>
                        </template>
                    </stats-card>

                </div>
                <div class="col-xl-3 col-lg-6">
                    <stats-card title="Performance"
                                type="gradient-info"
                                sub-title="49,65%"
                                icon="ni ni-chart-bar-32"
                                class="mb-4 mb-xl-0"
                    >

                        <template slot="footer">
                            <span class="text-success mr-2"><i class="fa fa-arrow-up"></i> 54.8%</span>
                            <span class="text-nowrap">Since last month</span>
                        </template>
                    </stats-card>
                </div> -->
            <!-- </div> -->
        </base-header>

        <div class="container-fluid mt--7">
            <div class="row">
                <div class="col">
                    <div class="card shadow">
                        <div class="card-header bg-transparent">
                          <base-button class="btn-primary btn-sm" style="margin-top:-20px;" v-on:click="back">{{texts.back}}</base-button>
                            <h3 class="mb-0" v-if="textleft" >Edit deliverable</h3>
                            <h3 class="mb-0" v-else style="text-align : right">تعديل المخرجات</h3>
                        </div>
                        <div class="card-body">
                           <form> <!--v-on:submit.prevent="onSubmit(title, message, );">-->
                            <fieldset class="form-group">
                            <div class="row">
                              <div class="col-md-6">
                                <h3 v-if="textleft">Enter Title</h3>
                                <h3 v-else style="text-align:right;">أدخل العنوان</h3>

                                <base-input v-if="textleft" alternative placeholder="Title" v-model="title" ></base-input>
                                <base-input v-else alternative placeholder="العنوان" v-model="title" ></base-input>
                              </div>
                            </div>

                          </fieldset>
                          <fieldset class="form-group">
                            <div class="row">
                              <div class="col-md-6">
                                <h3 v-if="textleft">Enter Description</h3>
                                <h3 v-else style="text-align:right;">أدخل الوصف</h3>

                                <textarea v-if="textleft" class="form-control" rows="3" alternative placeholder="Description" v-model="description" ></textarea>
                                <textarea v-else class="form-control" rows="3" alternative placeholder="الوصف" v-model="description" ></textarea>
                              </div>
                            </div>

                          </fieldset>
                          <div class="row">
                          <div v-if ="textleft" class="col-md-6">
                                <!-- <h3>Select Entity</h3> -->
                                <base-dropdown >
                                <!-- <base-button slot="title" type="secondary" class="dropdown-toggle">
                                   Select Entity
                                 </base-button> -->
                                 <base-button v-if="entities" id="entityDropDown"  slot="title" type="secondary" @change="onChange($event)" class="dropdown-toggle" v-model="entity">
                                   {{entity}}
                                 </base-button>
                                    <!-- <base-button v-if="entities" id="entityDropDown"  slot="title" type="secondary" @change="onChange($event)" class="dropdown-toggle" v-model="entity">
                                      {{entity}}
                                    </base-button> -->
                                    <span v-for="(fieldName, pos1) in entities" :key="pos1" class="dropdown-item" :value="fieldName" v-on:click="onChange">{{fieldName}}</span>
                                    <!-- <base-button class="dropdown-item" value="Finance" v-on:click="onChange">Finance</base-button>
                                    <base-button class="dropdown-item" value="Operations" v-on:click="onChange">Operations</base-button>
                                    <base-button class="dropdown-item" value="Accounting" v-on:click="onChange">Accounting</base-button>  -->

                                  </base-dropdown>
                              </div>
                              <div v-else class="col-md-6 text-right">
                                    <!-- <h3>Select Entity</h3> -->
                                    <base-dropdown >
                                    <!-- <base-button slot="title" type="secondary" class="dropdown-toggle">
                                       Select Entity
                                     </base-button> -->
                                     <base-button v-if="entities" id="entityDropDown"  slot="title" type="secondary" @change="onChange($event)" class="dropdown-toggle" v-model="entity">
                                       {{entity}}
                                     </base-button>
                                        <!-- <base-button v-if="entities" id="entityDropDown"  slot="title" type="secondary" @change="onChange($event)" class="dropdown-toggle" v-model="entity">
                                          {{entity}}
                                        </base-button> -->
                                        <span v-for="(fieldName, pos1) in entities" :key="pos1" class="dropdown-item" :value="fieldName" v-on:click="onChange">{{fieldName}}</span>
                                        <!-- <base-button class="dropdown-item" value="Finance" v-on:click="onChange">Finance</base-button>
                                        <base-button class="dropdown-item" value="Operations" v-on:click="onChange">Operations</base-button>
                                        <base-button class="dropdown-item" value="Accounting" v-on:click="onChange">Accounting</base-button>  -->

                                      </base-dropdown>
                                  </div>
                            </div>
                            <div class="row">
                              <div v-if ="textleft" class="col-md-6">
                                    <!-- <h3>Select Entity</h3> -->
                                    <base-dropdown >
                                    <!-- <base-button slot="title" type="secondary" class="dropdown-toggle">
                                       Select Entity
                                     </base-button> -->
                                     <base-button v-if="phases" id="phaseDropDown"  slot="title" type="secondary" @change="onChangePhase($event)" class="dropdown-toggle" v-model="phase">
                                       {{phase}}
                                     </base-button>
                                        <!-- <base-button v-if="entities" id="entityDropDown"  slot="title" type="secondary" @change="onChange($event)" class="dropdown-toggle" v-model="entity">
                                          {{entity}}
                                        </base-button> -->
                                        <span v-for="(fieldName, pos1) in phases" :key="pos1" class="dropdown-item" :value="fieldName" v-on:click="onChangePhase">{{fieldName.name}}</span>
                                        <!-- <base-button class="dropdown-item" value="Finance" v-on:click="onChange">Finance</base-button>
                                        <base-button class="dropdown-item" value="Operations" v-on:click="onChange">Operations</base-button>
                                        <base-button class="dropdown-item" value="Accounting" v-on:click="onChange">Accounting</base-button>  -->

                                      </base-dropdown>
                                  </div>
                                  <div v-else class="col-md-6 text-right">
                                        <!-- <h3>Select Entity</h3> -->
                                        <base-dropdown >
                                        <!-- <base-button slot="title" type="secondary" class="dropdown-toggle">
                                           Select Entity
                                         </base-button> -->
                                         <base-button v-if="phases" id="phaseDropDown"  slot="title" type="secondary" @change="onChangePhase($event)" class="dropdown-toggle" v-model="phase">
                                           {{phase}}
                                         </base-button>
                                            <!-- <base-button v-if="entities" id="entityDropDown"  slot="title" type="secondary" @change="onChange($event)" class="dropdown-toggle" v-model="entity">
                                              {{entity}}
                                            </base-button> -->
                                            <span v-for="(fieldName, pos1) in phases" :key="pos1" class="dropdown-item" :value="fieldName" v-on:click="onChangePhase">{{fieldName.name}}</span>
                                            <!-- <base-button class="dropdown-item" value="Finance" v-on:click="onChange">Finance</base-button>
                                            <base-button class="dropdown-item" value="Operations" v-on:click="onChange">Operations</base-button>
                                            <base-button class="dropdown-item" value="Accounting" v-on:click="onChange">Accounting</base-button>  -->

                                          </base-dropdown>
                                      </div>
                            <!-- <div class="col-md-6"> -->

                                  <!-- <h3>Select Entity</h3>
                                  <base-dropdown>
                                    <base-button v-if="entities" id="entityDropDown"  slot="title" type="secondary" @change="onChange($event)" class="dropdown-toggle" v-model="entity">
                                        {{entity}}
                                      </base-button>
                                      <base-button v-for="(fieldName, pos1) in entities" :key="pos1" class="dropdown-item" :value="fieldName" v-on:click="onChange">{{fieldName}}</base-button>
                                    </base-dropdown> -->
                                <!-- </div> -->
                              </div>

                            <div class="row">
                              <div v-if="textleft" class="col-md-6">
                                <!-- <h3>Report Type</h3> -->
                                <base-dropdown>
                                    <base-button slot="title" type="secondary" @change="onChangeRType($event)" class="dropdown-toggle" v-model="report_type">
                                      {{displayFindingsType(report_type)}}
                                    </base-button>
                                    <span class="dropdown-item" value="Internal Audit" v-on:click="onChangeRType">{{texts.internal_audit}}</span>
                                    <span class="dropdown-item" value="Risk Assessment" v-on:click="onChangeRType">Risk Assessment</span>
                                    <span class="dropdown-item" value="Forensic" v-on:click="onChangeRType">{{texts.forensic}}</span>
                                    <span class="dropdown-item" value="Compliance Audit" v-on:click="onChangeRType">Compliance Audit</span>
                                    <span class="dropdown-item" value="Remedial Actions" v-on:click="onChangeRType">Remedial Actions</span>
                                    <span class="dropdown-item" value="Other" v-on:click="onChangeRType">Other</span>
                                  </base-dropdown>
                              </div>
                              <div v-else class="col-md-7 text-right">
                                <!-- <h3>Report Type</h3> -->
                                <base-dropdown>
                                    <base-button id="reportType" slot="title" type="secondary" @change="onChangeRType($event)" class="dropdown-toggle" v-model="report_type">
                                      {{displayFindingsType(report_type)}}
                                    </base-button>
                                    <span class="dropdown-item" value="Internal Audit" v-on:click="onChangeRType">{{texts.internal_audit}}</span>
                                    <span class="dropdown-item" value="Risk Assessment" v-on:click="onChangeRType">{{texts.riskassessment}}</span>
                                    <span class="dropdown-item" value="Forensic" v-on:click="onChangeRType">{{texts.forensic}}</span>
                                    <span class="dropdown-item" value="Compliance Audit" v-on:click="onChangeRType">{{texts.compliance_audit}}</span>
                                    <span class="dropdown-item" value="Remedial Actions" v-on:click="onChangeRType">{{texts.remedial_actions}}</span>
                                    <span class="dropdown-item" value="Other" v-on:click="onChangeRType">{{texts.other}}</span>


                                  </base-dropdown>
                              </div>
                            </div>
                            <br>
                            <div class="row" v-if="report_type == 'Internal Audit'">
                              <div class="row">

                                  <div class="col-5">
                                <span class="badge badge-pill badge-danger" style="font-size: 10px;background-color: #bf2718; color: white;margin-right: 1px;margin-top: 20px;">{{texts.very_high}}</span>
                                </div>
                                <div class="col-4">
                                <base-input alternative placeholder="" v-model="very_high_findings" style="width:55px; margin-top: 10px;text-align: center;"></base-input>
                              </div>

                              </div>
                              <div class="row">
                                <div class="col-4">
                                <span class="badge badge-pill badge-danger" style="font-size: 10px;background-color: #E74C3C; color: white;margin-right: 1px;margin-top: 20px;" align="center">{{texts.high}}</span>
                              </div>
                                <br>
                                <div class="col-4">
                                <base-input alternative placeholder="" v-model="high_findings" style="width:55px; margin-top: 10px;text-align: center;" ></base-input>
                              </div>
                              </div>
                              <div class="row">
                                <div class="col-5">
                                <span class="badge badge-pill badge-danger" style="font-size: 10px;background-color: #F39C12; color: white;margin-right: 1px;margin-top: 20px;">{{texts.medium}}</span>
                              </div>
                                <br>
                                <div class="col-4">
                                <base-input alternative placeholder="" v-model="medium_findings" style="width:55px; margin-top: 10px;text-align: center;" ></base-input>
                              </div>
                              </div>
                              <div class="row">
                                <div class="col-4">
                                <span class="badge badge-pill badge-danger" style="font-size: 10px;background-color: #F4D03F; color: white;margin-right: 1px;margin-top: 20px;">{{texts.low}}</span>
                              </div>
                                <br>
                                <div class="col-4">
                                <base-input alternative placeholder="" v-model="low_findings" style="width:55px; margin-top: 10px;text-align: center;"></base-input>
                              </div>
                              </div>
                              <div class="row">
                                <div class="col-5">
                                <span class="badge badge-pill badge-danger" style="font-size: 10px;background-color: #2ecc71; color: white;margin-right: 1px;margin-top: 20px;">{{texts.very_low}}</span>
                              </div>
                                <br>
                                <div class="col-4">
                                <base-input alternative placeholder="" v-model="very_low_findings" style="width:55px; margin-top: 10px;text-align: center;"></base-input>
                              </div>
                              </div>
                            </div>

                            <div class="row" v-else-if="report_type == 'Risk Assessment'">
                              <div class="row">

                              <div class="col-3">
                                <span class="badge badge-pill badge-danger" style="font-size: 12px;background-color: #2ecc71; color: white;margin-right: 1px;margin-top: 20px;">A</span>
                                </div>
                                <div class="col-4">
                                <base-input alternative placeholder="" v-model="a_findings" style="width:55px; margin-top: 10px;text-align: center;"></base-input>
                              </div>

                              </div>
                              <div class="row">
                                <div class="col-3">
                                <span class="badge badge-pill badge-danger" style="font-size: 12px;background-color: #f1c40f; color: white;margin-right: 1px;margin-top: 20px;" align="center">B</span>
                              </div>
                                <br>
                                <div class="col-4">
                                <base-input alternative placeholder="" v-model="b_findings" style="width:55px; margin-top: 10px;text-align: center;" ></base-input>
                              </div>
                              </div>
                              <div class="row">
                                <div class="col-3">
                                <span class="badge badge-pill badge-danger" style="font-size: 12px;background-color: #e67e22; color: white;margin-right: 1px;margin-top: 20px;">C</span>
                              </div>
                                <br>
                                <div class="col-4">
                                <base-input alternative placeholder="" v-model="c_findings" style="width:55px; margin-top: 10px;text-align: center;" ></base-input>
                              </div>
                              </div>
                              <div class="row">
                                <div class="col-3">
                                <span class="badge badge-pill badge-danger" style="font-size: 12px;background-color: #e74c3c; color: white;margin-right: 1px;margin-top: 20px;">D</span>
                              </div>
                                <br>
                                <div class="col-4">
                                <base-input alternative placeholder="" v-model="d_findings" style="width:55px; margin-top: 10px;text-align: center;"></base-input>
                              </div>
                              </div>
                            </div>

                            <div class="row" v-else-if="report_type == 'Compliance Audit'">
                              <div class="row">

                              <div class="col-3">
                                <span class="badge badge-pill badge-danger" style="font-size: 12px;background-color: #2ecc71; color: white;margin-right: 1px;margin-top: 20px;">A</span>
                                </div>
                                <div class="col-4">
                                <base-input alternative placeholder="" v-model="always_findings" style="width:55px; margin-top: 10px;text-align: center;"></base-input>
                              </div>

                              </div>
                              <div class="row">
                                <div class="col-3">
                                <span class="badge badge-pill badge-danger" style="font-size: 12px;background-color: #f1c40f; color: white;margin-right: 1px;margin-top: 20px;" align="center">M</span>
                              </div>
                                <br>
                                <div class="col-4">
                                <base-input alternative placeholder="" v-model="mostly_findings" style="width:55px; margin-top: 10px;text-align: center;" ></base-input>
                              </div>
                              </div>
                              <div class="row">
                                <div class="col-3">
                                <span class="badge badge-pill badge-danger" style="font-size: 12px;background-color: #e67e22; color: white;margin-right: 1px;margin-top: 20px;">S</span>
                              </div>
                                <br>
                                <div class="col-4">
                                <base-input alternative placeholder="" v-model="sometimes_findings" style="width:55px; margin-top: 10px;text-align: center;" ></base-input>
                              </div>
                              </div>
                              <div class="row">
                                <div class="col-3">
                                <span class="badge badge-pill badge-danger" style="font-size: 12px;background-color: #e74c3c; color: white;margin-right: 1px;margin-top: 20px;">N</span>
                              </div>
                                <br>
                                <div class="col-4">
                                <base-input alternative placeholder="" v-model="never_findings" style="width:55px; margin-top: 10px;text-align: center;"></base-input>
                              </div>
                              </div>
                              <div class="row">
                                <div class="col-3">
                                <span class="badge badge-pill badge-danger" style="font-size: 12px;background-color: #7f8c8d; color: white;margin-right: 1px;margin-top: 20px;">U</span>
                              </div>
                                <br>
                                <div class="col-4">
                                <base-input alternative placeholder="" v-model="untested_findings" style="width:55px; margin-top: 10px;text-align: center;"></base-input>
                              </div>
                              </div>
                            </div>

                            <div class="row" v-else-if="report_type == 'Remedial Actions'">
                              <div class="row">

                              <div class="col-5">
                                <span class="badge badge-pill badge-danger" style="font-size: 10px;background-color: #2ecc71; color: white;margin-right: 1px;margin-top: 20px;">{{texts.implemented}}</span>
                                </div>
                                <div class="col-4">
                                <base-input alternative placeholder="" v-model="implemented_findings" style="width:55px; margin-top: 10px;text-align: center;"></base-input>
                              </div>

                              </div>
                              <div class="row">
                                <div class="col-5">
                                <span class="badge badge-pill badge-danger" style="font-size: 10px;background-color: #f1c40f; color: white;margin-right: 1px;margin-top: 20px;" align="center">{{texts.in_progress}}</span>
                              </div>
                                <br>
                                <div class="col-4">
                                <base-input alternative placeholder="" v-model="in_progress_findings" style="width:55px; margin-top: 10px;text-align: center;" ></base-input>
                              </div>
                              </div>
                              <div class="row">
                                <div class="col-5">
                                <span class="badge badge-pill badge-danger" style="font-size: 10px;background-color: #7f8c8d; color: white;margin-right: 1px;margin-top: 20px;">{{texts.not_started}}</span>
                              </div>
                                <br>
                                <div class="col-4">
                                <base-input alternative placeholder="" v-model="not_started_findings" style="width:55px; margin-top: 10px;text-align: center;" ></base-input>
                              </div>
                              </div>
                              <div class="row">
                                <div class="col-4">
                                <span class="badge badge-pill badge-danger" style="font-size: 10px;background-color: #e74c3c; color: white;margin-right: 1px;margin-top: 20px;">{{texts.overdue}}</span>
                              </div>
                                <br>
                                <div class="col-4">
                                <base-input alternative placeholder="" v-model="overdue_findings" style="width:55px; margin-top: 10px;text-align: center;"></base-input>
                              </div>
                              </div>
                            </div>
                            <!-- </div> -->
                            <br>
                           <div class="row">
                              <div v-if="textleft" class="col-md-6">
                                <h3>Select File</h3>
                                  <input ref="file" type="file" name="deliverableFile" accept="application/pdf" v-on:change="onSelect"/>
                              </div>
                              <div v-else class="col-md-6 text-right">
                                <h3  style="text-align:right;">حدد الملف</h3>
                                  <input ref="file" type="file" name="deliverableFile" accept="application/pdf" v-on:change="onSelect"/>
                              </div>
                            </div>


                             <br>
                             <!-- <fieldset class="form-group">
                            <div class="row">
                              <div class="col-md-2">
                                <h3>Enter Budget</h3>
                                <center>
                                <base-input placeholder="Budget" v-model="budget" type="number" style="text-align:center;"></base-input>
                              </center>
                              </div>
                            </div>
                          </fieldset> -->
                            <fieldset class="form-group">
                            <div class="row">
                              <div v-if="textleft" class="col-md-6">
                                 <base-button type="success" v-on:click="onSubmit">{{buttontitle}}</base-button>
                              </div>
                              <div v-else class="col-md-6 text-right">
                                 <base-button type="success" v-on:click="onSubmit">{{buttontitle}}</base-button>
                              </div>
                            </div>
                          </fieldset>
                          </form>
<!--                                 <div class="col-lg-3 col-md-6"
                                     v-for="(icon, index) in icons" :key="icon.name + index">
                                    <button type="button"
                                            v-b-tooltip.hover.top
                                            :title="icon.name"
                                            v-clipboard:copy="icon.name"
                                            v-clipboard:success="onCopy"
                                            class="btn-icon-clipboard" data-clipboard-text="air-baloon">
                                        <div>
                                            <i :class="icon.name"></i>
                                            <span>{{icon.name.substring(6)}}</span>
                                        </div>
                                    </button>
                                </div> -->
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>
<script>
  import { mapState } from "vuex";
  import { GET_ENTITIES, GET_ENTITIES_FINDINGS, UPLOAD_DELIVERABLE, GET_PHASES, GET_DELIVERABLE_INFO, EDIT_DELIVERABLE, EDIT_DELIVERABLE_NO_FILE } from "@/store/actions.type";
  import store from "@/store";
  import Vue from 'vue'
  import VueClipboard from 'vue-clipboard2'
  import BTooltipDirective from 'bootstrap-vue/es/directives/tooltip'
  import flatPicker from "vue-flatpickr-component";
  import "flatpickr/dist/flatpickr.css";
  import UserService from "@/common/user.service";

  import { mapGetters } from "vuex";
  Vue.use(VueClipboard)
  export default {
    directives: {
      'b-tooltip': BTooltipDirective
    },
    components: {flatPicker},
    data() {
      return {
        textleft : UserService.getLanguage() === "ltr" ? true : false,
        report_type : UserService.getLanguage() === "ltr" ? "Report Type" : "نوع التقرير",
        texts : {
          internal_audit : UserService.getLanguage() === "ltr" ? "Internal Audit" : "التدقيق الداخلي",
          riskassessment : UserService.getLanguage() === "ltr" ? "Risk Assessment" : "تقييم المخاطر",
          forensic : UserService.getLanguage() === "ltr" ? "Forensic" : "تحقيقات الاحتيال",
          compliance_audit : UserService.getLanguage() === "ltr" ? "Compliance Audit" : "تدقيق مدى الالتزام",
          remedial_actions : UserService.getLanguage() === "ltr" ? "Remedial Actions" : "إجراءات تصحيحية",
          other : UserService.getLanguage() === "ltr" ? "Other" : "أخرى",
          very_low : UserService.getLanguage() === "ltr" ? "Very Low" : "متدني للغاية",
          low : UserService.getLanguage() === "ltr" ? "Low" : "متدني",
          medium : UserService.getLanguage() === "ltr" ? "Medium" : "متوسط",
          high : UserService.getLanguage() === "ltr" ? "High" : "مرتفع",
          very_high : UserService.getLanguage() === "ltr" ? "Very High" : "مرتفع جدا",
          implemented : UserService.getLanguage() === "ltr" ? "Implemented" : "نفذت",
          in_progress : UserService.getLanguage() === "ltr" ? "In Progress" : "قيد التنفيذ",
          overdue : UserService.getLanguage() === "ltr" ? "Overdue" : "متأخر",
          not_started : UserService.getLanguage() === "ltr" ? "Not Started" : "لم تبدأ",
          back : UserService.getLanguage() === "rtl" ? "رجوع" : "Back",
          // internal_audit : "Internal Audit",
          // internal_audit : UserService.getLanguage() === "ltr" ? "Internal Audit" : "تدقيق داخلي",
          // forensic :"Forensic"
          // forensic : UserService.getLanguage() === "ltr" ? "Forensic" : "قضائي"
        },
        buttontitle : UserService.getLanguage() === "ltr" ? 'Edit Deliverable' : "تعديل المخرجات",
        title : '',
        budget : '',
        file : '',
        description : '',
        phase : UserService.getLanguage() === "ltr" ? "Select Phase" : "حدد المرحلة",
        phases : [],
        // entity : store.getters.entitiesState ? store.getters.entitiesState[0] : '',
        entity : UserService.getLanguage() === "ltr" ? "Select Entity" : "حدد وحدة العمل" ,
        entities : store.getters.entitiesState,
        message : '',
        very_high_findings : 0,
        high_findings : 0,
        medium_findings : 0,
        low_findings : 0,
        very_low_findings : 0,
        a_findings : 0,
        b_findings : 0,
        c_findings : 0,
        d_findings : 0,
        implemented_findings : 0,
        in_progress_findings : 0,
        not_started_findings : 0,
        overdue_findings : 0,
        always_findings : 0,
        mostly_findings : 0,
        sometimes_findings : 0,
        never_findings : 0,
        untested_findings : 0,
        language : UserService.getLanguage(),
        tiers : {
          all : true,
          starter : false,
          silver : false,
          gold : false,
          platinum : false
        },
        dates: {
          simple: new Date().toISOString().split(" ")[0]
        }
      }
    },
    computed: {
        ...mapGetters(["isAuthenticated", "entitiesState"])
        // ,
        // subscribers() {
        //     console.log(this.$route.params.subscribers);
        //   return this.$route.params.subscribers;
        // }
      },
    mounted() {
      Promise.all([
        store.dispatch(GET_DELIVERABLE_INFO, this.$route.params.token)
      ]).then((data) => {
        console.log(data);

        console.log(data[0]['data'].title);

        this.title = data[0]['data'].title;
        this.description = data[0]['data'].description;
        this.entity = data[0]['data'].entity;
        this.phase = data[0]['data'].phase;
        this.report_type = data[0]['data'].type;

        console.log("GETTING CURRENT PHASE : " + data[0]['data'].entity);
        this.getCurrentPhase(data[0]['data'].entity);
        console.log("ON CHANGE PHASE : " + data[0]['data'].phase);

        console.log("GETTING FINDINGS : " + data[0]['data'].entity);


        // console.log("TITLE : " + data[0]['data'].title);
        // console.log("DESCRIPTION : " + this.description);

      });
      Promise.all([
        store.dispatch(GET_ENTITIES, UserService.getAssignmentId())
      ]).then((data) => {
        console.log(data[0]['data']);
          this.loaded = true;
          // if (store.getters.entitiesState) {

          // }

          console.log(store.getters.entitiesState);
          this.entities = data[0]['data'];
          // this.teammembers = teamMembers;
          // console.log(this.stores);
          // console.log(this.visitsdata);
          // this.initBigChart(this.stores[0]);
          // this.redBarChart.chartData.datasets[0].data = [this.recurringcount, this.newcount];
          // this.retentionChart.chartData.datasets[0].data = Object.values(this.customerdetentiondata);
          // this.retentionChart.chartData.labels = Object.keys(this.customerdetentiondata);
      });
    },
    methods: {
      back() {
        window.history.back();
        // this.$router.push({ name: 'sendsms' });
      },
      displayFindingsType(finding_type) {
        // console.log("HELLO");
        if (this.language === 'rtl') {
          if (finding_type === "Internal Audit") {
            return this.texts.internal_audit;
          }
          else if (finding_type === "Risk Assessment") {
            return this.texts.riskassessment;
          }
          else if (finding_type === "Compliance Audit") {
            return this.texts.compliance_audit;
          }
          else if (finding_type === "Forensic") {
            return this.texts.forensic;
          }
          else if (finding_type === "Other") {
            return this.texts.other;
          }
          else if (finding_type === "Remedial Actions") {
            return this.texts.remedial_actions;
          }
          else {
            return finding_type;
          }
        }
        else {
          return finding_type;
        }
      },
      onSelect() {
          const file1 = this.$refs.file.files[0]
          this.file = file1;
      },
      onSubmit() {
        let hasFile = this.file !== '';

        if (this.file !== '') {
          if (this.textleft) {
              this.buttontitle = "Uploading..";
          }
          else {
            this.buttontitle = ".. جاري التحميل";
          }

        }

        console.log("TITLE : " + this.title);
        // console.log("MESSAGE : " + this.message);
        // console.log("TIMESLOT : " + this.timeslot);
        // console.log("TIERS : ");
        // console.log(this.tiers);
        // console.log("DATE : " + this.dates.simple);
            // if (email !== '' && password !== '') {
            //     this.localerrors = null;

                // let formData = {'deliverableFile' : this.file, 'assignment_id' : "5e03d4c5c060d91d3c228b2a", 'title' : this.title, 'type' : this.report_type, 'entity' : this.entity, 'very_high_findings' : this.very_high_findings, 'high_findings' : this.high_findings, 'medium_findings' : this.medium_finding, 'low_findings' : this.low_findings, 'very_low_findings' : this.very_low_findings};
                let formData = new FormData();
                let jsonForm = new Map();

                formData.append('deliverableFile', this.file);
                jsonForm.set('deliverableFile', this.file);
                formData.append('deliverable_id', this.$route.params.token);
                jsonForm.set('deliverable_id', this.$route.params.token);
                formData.append('assignment_id', UserService.getAssignmentId());
                jsonForm.set('assignment_id', UserService.getAssignmentId());
                formData.append('title', this.title);
                jsonForm.set('title', this.title);
                formData.append('description', this.description);
                jsonForm.set('description', this.description);
                formData.append('type', this.report_type);
                jsonForm.set('type', this.report_type);
                formData.append('entity', this.entity);
                jsonForm.set('entity', this.entity);
                formData.append('phase', this.phase);
                jsonForm.set('phase', this.phase);

                if (String(this.report_type) === "Internal Audit") {
                  formData.append('very_high_findings', this.very_high_findings);
                  jsonForm.set('very_high_findings', this.very_high_findings);
                  formData.append('high_findings', this.high_findings);
                  jsonForm.set('high_findings', this.high_findings);
                  formData.append('medium_findings', this.medium_findings);
                  jsonForm.set('medium_findings', this.medium_findings);
                  formData.append('low_findings', this.low_findings);
                  jsonForm.set('low_findings', this.low_findings);
                  formData.append('very_low_findings', this.very_low_findings);
                  jsonForm.set('very_low_findings', this.very_low_findings);
                }
                else if (String(this.report_type) === "Risk Assessment") {
                  formData.append('a_findings', this.a_findings);
                  jsonForm.set('a_findings', this.a_findings);
                  formData.append('b_findings', this.b_findings);
                  jsonForm.set('b_findings', this.b_findings);
                  formData.append('c_findings', this.c_findings);
                  jsonForm.set('c_findings', this.c_findings);
                  formData.append('d_findings', this.d_findings);
                  jsonForm.set('d_findings', this.d_findings);
                }
                else if (String(this.report_type) === "Remedial Actions") {
                  formData.append('implemented_findings', this.implemented_findings);
                  jsonForm.set('implemented_findings', this.implemented_findings);
                  formData.append('in_progress_findings', this.in_progress_findings);
                  jsonForm.set('in_progress_findings', this.in_progress_findings);
                  formData.append('not_started_findings', this.not_started_findings);
                  jsonForm.set('not_started_findings', this.not_started_findings);
                  formData.append('overdue_findings', this.overdue_findings);
                  jsonForm.set('overdue_findings', this.overdue_findings);
                }
                else if (String(this.report_type) === "Compliance Audit") {
                  formData.append('always_findings', this.always_findings);
                  jsonForm.set('always_findings', this.always_findings);
                  formData.append('mostly_findings', this.mostly_findings);
                  jsonForm.set('mostly_findings', this.mostly_findings);
                  formData.append('sometimes_findings', this.sometimes_findings);
                  jsonForm.set('sometimes_findings', this.sometimes_findings);
                  formData.append('never_findings', this.never_findings);
                  jsonForm.set('never_findings', this.never_findings);
                  formData.append('untested_findings', this.untested_findings);
                  jsonForm.set('untested_findings', this.untested_findings);
                }


                // console.log(jsonForm);

                if (hasFile) {
                  Promise.all([
                    store.dispatch(EDIT_DELIVERABLE, formData),

                  ]).then(() => {
                    if (this.textleft) {
                      this.$notify({
                        type: 'success',
                        title: 'Report Edited Successfully'
                      });
                    }
                    else {
                      this.$notify({
                        type: 'success',
                        title: 'تم تعديل التقرير بنجاح'
                      });

                    }

                    this.isLoading = false;
                    // this.$router.push({ name: 'viewdeliverables', params: { token:  this.entity, phase : this.phase} });
                    this.$router.push({ name: "overview" })
                  });
                }
                else {
                  Promise.all([
                    store.dispatch(EDIT_DELIVERABLE_NO_FILE, Object.fromEntries(jsonForm)),

                  ]).then(() => {
                    if (this.textleft) {
                      this.$notify({
                        type: 'success',
                        title: 'Report Edited Successfully'
                      });
                    }
                    else {
                      this.$notify({
                        type: 'success',
                        title: 'تم تعديل التقرير بنجاح'
                      });

                    }

                    this.isLoading = false;
                    // this.$router.push({ name: 'viewdeliverables', params: { token:  this.entity, phase : this.phase} });
                    this.$router.push({ name: "overview" })
                  });
                }

                // console.log(formData);
                // console.log(UPLOAD_DELIVERABLE);
                //
            // }
            // else {

            //   this.localerrors = "Email or Password cannot be empty !"

            // }

          // this.$store
          //   .dispatch(LOGIN, { email, password })
          //   .then(() => this.$router.push({ name: "dashboard" }));
        },
        getEntityFindings(assignmentId, entityName) {
          Promise.all([
            store.dispatch(GET_ENTITIES_FINDINGS, [assignmentId, entityName])
          ]).then((data) => {
            console.log(data[0]['data']);
              this.loaded = true;
              console.log("GOT FINDINGS");
              console.log(store.getters.entitiesState);

              // this.teammembers = teamMembers;
              // console.log(this.stores);
              // console.log(this.visitsdata);
              // this.initBigChart(this.stores[0]);
              // this.redBarChart.chartData.datasets[0].data = [this.recurringcount, this.newcount];
              // this.retentionChart.chartData.datasets[0].data = Object.values(this.customerdetentiondata);
              // this.retentionChart.chartData.labels = Object.keys(this.customerdetentiondata);
          });
        },
        getCurrentPhase(entity) {
          Promise.all([
            store.dispatch(GET_PHASES, [UserService.getAssignmentId(),entity])
          ]).then((data) => {
            console.log("PHASES");
            console.log(data[0]['data']);

              this.phases = data[0]['data'];
              this.loaded = true;
              this.onChangePhase({target : {innerText : this.phase}});

              // this.current_phase_date = data[0]['data']['start_date'];
              // this.dates.simple = new Date(data[0]['data']['start_date']).toISOString().split(" ")[0];
              // this.current_phase_name = data[0]['data']['name'];



              // this.teammembers = teamMembers;
              // console.log(this.stores);
              // console.log(this.visitsdata);
              // this.initBigChart(this.stores[0]);
              // this.redBarChart.chartData.datasets[0].data = [this.recurringcount, this.newcount];
              // this.retentionChart.chartData.datasets[0].data = Object.values(this.customerdetentiondata);
              // this.retentionChart.chartData.labels = Object.keys(this.customerdetentiondata);
          });
        },
      onChange(event) {
          this.entity = event.target.innerText;
          // console.log("TAG VALUE " + event.target.value);
          console.log("TAG VALUE " + event.target.innerText);
          this.getCurrentPhase(event.target.innerText);
          this.getEntityFindings(UserService.getAssignmentId(), event.target.innerText);

      },
      onChangePhase(event) {

          // this.entity = event.target.value;
          this.phase = event.target.innerText;
          console.log(event.target.innerText);
          console.log(this.phases);
          let chosenPhase;
          for (let y = 0; y< this.phases.length; y++) {
              if (String(this.phases[y].name).replace(/ /g,'') === String(event.target.innerText).replace(/ /g,'')) {
                chosenPhase = this.phases[y];
              }
          }
          console.log("CHOSEN PHASE");
          console.log(chosenPhase);
          chosenPhase.findings_type = this.report_type;
          // this.report_type = String(chosenPhase.findings_type);
          if (String(chosenPhase.findings_type) === "Internal Audit") {
            this.very_high_findings = chosenPhase.very_high_findings;
            this.high_findings = chosenPhase.high_findings;
            this.medium_findings = chosenPhase.medium_findings;
            this.low_findings = chosenPhase.low_findings;
            this.very_low_findings = chosenPhase.very_low_findings;
          }
          else if (String(chosenPhase.findings_type) === "Risk Assessment") {
            this.a_findings = chosenPhase.a_findings;
            this.b_findings = chosenPhase.b_findings;
            this.c_findings = chosenPhase.c_findings;
            this.d_findings = chosenPhase.d_findings;
          }
          else if (String(chosenPhase.findings_type) === "Compliance Audit") {
            this.always_findings = chosenPhase.always_findings;
            this.mostly_findings = chosenPhase.mostly_findings;
            this.sometimes_findings = chosenPhase.sometimes_findings;
            this.never_findings = chosenPhase.never_findings;
            this.untested_findings = chosenPhase.untested_findings;
          }
          else if (String(chosenPhase.findings_type) === "Remedial Actions") {
            this.implemented_findings = chosenPhase.implemented_findings;
            this.in_progress_findings = chosenPhase.in_progress_findings;
            this.not_started_findings = chosenPhase.not_started_findings;
            this.overdue_findings = chosenPhase.overdue_findings;
          }



          // this.current_phase_name = event.target.innerText;
          // for (let i = 0; i < this.phases.length; i++) {
          //   if (this.phases[i].name === event.target.innerText) {
          //     if (this.phases[i].actual_start_date !== "-") {
          //         this.start_date = this.phases[i].actual_start_date;
          //         this.start_date_set = true;
          //     }
          //     else {
          //       this.start_date = new Date().toISOString().split("T")[0];
          //       this.start_date_set = false;
          //     }
          //     if (this.phases[i].actual_end_date !== "-") {
          //         this.end_date = this.phases[i].actual_end_date;
          //         this.end_date_set = true;
          //     }
          //     else {
          //       this.end_date = new Date().toISOString().split("T")[0];
          //       this.end_date_set = false;
          //     }
          //
          //   }
          // }
          // this.getCurrentPhase(event.target.innerText);
          console.log(event);
      },
      displayFindingsType(finding_type) {
        console.log("HELLO");
        console.log("FINDNIG TYPE");
        console.log(finding_type);
        // if (this.language === 'rtl') {
          if (finding_type === "Internal Audit") {
            return this.texts.internal_audit;
          }
          else if (finding_type === "Risk Assessment") {
            return this.texts.riskassessment;
          }
          else if (finding_type === "Compliance Audit") {
            return this.texts.compliance_audit;
          }
          else if (finding_type === "Forensic") {
            return this.texts.forensic;
          }
          else if (finding_type === "Other") {
            return this.texts.other;
          }
          else if (finding_type === "Remedial Actions") {
            return this.texts.remedial_actions;
          }
          else {
            return finding_type;
          }
        // }
        // else {
        //   return finding_type;
        // }
      },
      displayFindingsTypeAR(finding_type) {
        // console.log("HELLO");
        if (this.language === 'rtl') {
          if (finding_type === "التدقيق الداخلي") {
            return "Internal Audit";
          }
          else if (finding_type === "تقييم المخاطر") {
            return "Risk Assessment";
          }
          else if (finding_type === "تدقيق مدى الالتزام") {
            return "Compliance Audit";
          }
          else if (finding_type === "تحقيقات الاحتيال") {
            return "Forensic";
          }
          else if (finding_type === "أخرى") {
            return "Other";
          }
          else if (finding_type === "إجراءات تصحيحية") {
            return "Remedial Actions";
          }
          else {
            return finding_type;
          }
        }
        else {
          return finding_type;
        }
      },
      onChangeRType(event) {
          // console.log(event.target.value);
          // console.log(event.target.innerText);
          // console.log(this.displayFindingsType(event.target.innerText));
          // // if (event.target.value === "Internal Audit") {
          // //   document.getElementById('reportType').innerHTML = texts.internal_audit;
          // // }
          // // else {
          // //   document.getElementById('reportType').innerHTML = texts.forensic;
          // // }
          // this.report_type = this.displayFindingsType(event.target.innerText);
          // console.log(event);
      },
      onCopy() {
        this.$notify({
          type: 'success',
          title: 'Copied to clipboard'
        })
      }
    }
  };
</script>
<style></style>
